import { global as filters } from '../filters/index'
import { global as components } from '../components/index'
import { global as directives } from '../directives/index'
import { global as plugins } from './index';
import { global as mixins } from '../mixin/index';

export default {
    install(Vue){
        // 全局注册插件
        Object.keys(plugins).forEach(key => {
            Vue.use(plugins[key]);
        });

        // 全局注册组件
        Object.keys(components).forEach(key => {
            Vue.component(key, components[key]);
        });

        // 全局注册过滤器
        Object.keys(filters).forEach(key => {
            // console.log(key, filters[key]);
            Vue.filter(key, filters[key]);
        });

        // 全局注册指令
        Object.keys(directives).forEach(key => {
            Vue.directive(key, directives[key]);
        });

        // 全局注册mixin
        Object.keys(mixins).forEach(mixin => {
            Vue.mixin(mixins[mixin]);
        });
    }
}




// WEBPACK FOOTER //
// ./src/plugins/globalRegist.js